import { render, staticRenderFns } from "./Summary_Sagliknet.vue?vue&type=template&id=48aebcbc&"
import script from "./Summary_Sagliknet.vue?vue&type=script&lang=js&"
export * from "./Summary_Sagliknet.vue?vue&type=script&lang=js&"
import style0 from "./Summary_Sagliknet.vue?vue&type=style&index=0&id=48aebcbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports